export function getdata() {
	var obj = {
		
			list: {
				nsrlx: [{
					title: '产权所有人',
					label: 1,
				}, {
					title: '经营管理人',
					label: 2,
				}, {
					title: '承典人',
					label: 3,
				}, {
					title: '房屋代管人',
					label: 4,
				}, {
					title: '房屋使用人',
					label: 5,
				}, {
					title: '融资租赁承租人',
					label: 6,
				}],
				yt: [{
					title: '工业',
					label: 1,
				}, {
					title: '商业及办公',
					label: 2,
				}, {
					title: '住房',
					label: 2,
				}, {
					title: '其他',
					label: 2,
				}],
				tdqdfs: [{
					title: '划拨',
					label: 1,
				}, {
					title: '出让',
					label: 2,
				}, {
					title: '转让',
					label: 3,
				}, {
					title: '租赁',
					label: 4,
				}, {
					title: '其他',
					label: 5,
				}],
				bglxone: [{
					title: '权属转移',
					label: 1,
				}, {
					title: '其他',
					label: 2,
				}],
				bglxtou: [{
					title: '房产原值变更',
					label: 3,
				}, {
					title: '出租房产原值变更',
					label: 4,
				}, {
					title: '减免税变更',
					label: 5,
				}, {
					title: '申报租金收入变更',
					label: 6,
				}, {
					title: '其他',
					label: 7,
				}]
			},
			dataList: {
				ccxwfccj_sh: {
					disabledccxwfccj_sh: false,
					ccxwfccj_sh: {
						cellCode: "ccxwfccj_sh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_zgsws: {
					disabledccxwfccj_zgsws: true,
					ccxwfccj_zgsws: {
						cellCode: "ccxwfccj_zgsws",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_bh: {
					disabledccxwfccj_bh: true,
					ccxwfccj_bh: {
						cellCode: "ccxwfccj_bh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_mc: {
					disabledccxwfccj_mc: false,
					ccxwfccj_mc: {
						cellCode: "ccxwfccj_mc",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_cqzh: {
					disabledccxwfccj_cqzh: false,
					ccxwfccj_cqzh: {
						cellCode: "ccxwfccj_cqzh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_dydm: {
					disabledccxwfccj_dydm: false,
					ccxwfccj_dydm: {
						cellCode: "ccxwfccj_dydm",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_tdbh: {
					disabledccxwfccj_tdbh: false,
					ccxwfccj_tdbh: {
						cellCode: "ccxwfccj_tdbh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_dz: {
					sheng: '',
					shi: '',
					qu: '',
					xian: '',
					xz: '',
				},
				ccxwfccj_syqrmc: {
					disabledccxwfccj_syqrmc: false,
					ccxwfccj_syqrmc: {
						cellCode: "ccxwfccj_syqrmc",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_nsrlx: '',
				ccxwfccj_yt: '',
				ccxwfccj_qdsj: '',
				ccxwfccj_bglx: '',
				ccxwfccj_bgsj: '',
				ccxwfccj_mj: {
					disabledccxwfccj_mj: false,
					ccxwfccj_mj: {
						cellCode: "ccxwfccj_mj",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_czmj: {
					disabledccxwfccj_czmj: false,
					ccxwfccj_czmj: {
						cellCode: "ccxwfccj_czmj",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_yz: {
					disabledccxwfccj_yz: false,
					ccxwfccj_yz: {
						cellCode: "ccxwfccj_yz",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_czyz: {
					disabledccxwfccj_czyz: false,
					ccxwfccj_czyz: {
						cellCode: "ccxwfccj_czyz",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_jsbl: {
					disabledccxwfccj_jsbl: true,
					ccxwfccj_jsbl: {
						cellCode: "ccxwfccj_jsbl",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_2_1_1: {
					disabledccxwfccj_2_1_1: false,
					ccxwfccj_2_1_1: {
						cellCode: "ccxwfccj_2_1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_2_1_2: '',
				ccxwfccj_2_1_3: '',
				ccxwfccj_2_1_4: {
					disabledccxwfccj_2_1_4: false,
					ccxwfccj_2_1_4: {
						cellCode: "ccxwfccj_2_1_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_2_1_5: {
					disabledccxwfccj_2_1_5: false,
					ccxwfccj_2_1_5: {
						cellCode: "ccxwfccj_2_1_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_2_2_1: {
					disabledccxwfccj_2_2_1: false,
					ccxwfccj_2_2_1: {
						cellCode: "ccxwfccj_2_2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_2_2_2: '',
				ccxwfccj_2_2_3: '',
				ccxwfccj_2_2_4: {
					disabledccxwfccj_2_2_4: false,
					ccxwfccj_2_2_4: {
						cellCode: "ccxwfccj_2_2_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_2_2_5: {
					disabledccxwfccj_2_2_5: false,
					ccxwfccj_2_2_5: {
						cellCode: "ccxwfccj_2_2_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_2_3_1: {
					disabledccxwfccj_2_3_1: false,
					ccxwfccj_2_3_1: {
						cellCode: "ccxwfccj_2_3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_2_3_2: '',
				ccxwfccj_2_3_3: '',
				ccxwfccj_2_3_4: {
					disabledccxwfccj_2_3_4: false,
					ccxwfccj_2_3_4: {
						cellCode: "ccxwfccj_2_3_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccj_2_3_5: {
					disabledccxwfccj_2_3_5: false,
					ccxwfccj_2_3_5: {
						cellCode: "ccxwfccj_2_3_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
			},
			dataListI: {
				ccxwfccz_fcbh:{
					disabledccxwfccz_fcbh: true,
					ccxwfccz_fcbh: {
						cellCode: "ccxwfccz_fcbh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_fcmc:{
					disabledccxwfccz_fcmc: false,
					ccxwfccz_fcmc: {
						cellCode: "ccxwfccz_fcmc",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_zgsws:{
					disabledccxwfccz_zgsws: true,
					ccxwfccz_zgsws: {
						cellCode: "ccxwfccz_zgsws",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_sh:{
					disabledccxwfccz_sh: false,
					ccxwfccz_sh: {
						cellCode: "ccxwfccz_sh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_nc:{
					disabledccxwfccz_nc: false,
					ccxwfccz_nc: {
						cellCode: "ccxwfccz_nc",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_mj:{
					disabledccxwfccz_mj: false,
					ccxwfccz_mj: {
						cellCode: "ccxwfccz_mj",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_sbzjsr:{
					disabledccxwfccz_sbzjsr: false,
					ccxwfccz_sbzjsr: {
						cellCode: "ccxwfccz_sbzjsr",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_sszlqq:{
					disabledccxwfccz_sszlqq: false,
					ccxwfccz_sszlqq: {
						cellCode: "ccxwfccz_sszlqq",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_sszlqz:{
					disabledccxwfccz_sszlqz: false,
					ccxwfccz_sszlqz: {
						cellCode: "ccxwfccz_sszlqz",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				
				ccxwfccz_2_1_1: {
					disabledccxwfccz_2_1_1: false,
					ccxwfccz_2_1_1: {
						cellCode: "ccxwfccz_2_1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_2_1_2: '',
				ccxwfccz_2_1_3: '',
				ccxwfccz_2_1_4: {
					disabledccxwfccz_2_1_4: false,
					ccxwfccz_2_1_4: {
						cellCode: "ccxwfccz_2_1_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_2_1_5: {
					disabledccxwfccz_2_1_5: false,
					ccxwfccz_2_1_5: {
						cellCode: "ccxwfccz_2_1_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_2_2_1: {
					disabledccxwfccz_2_2_1: false,
					ccxwfccz_2_2_1: {
						cellCode: "ccxwfccz_2_2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_2_2_2: '',
				ccxwfccz_2_2_3: '',
				ccxwfccz_2_2_4: {
					disabledccxwfccz_2_2_4: false,
					ccxwfccz_2_2_4: {
						cellCode: "ccxwfccz_2_2_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_2_2_5: {
					disabledccxwfccz_2_2_5: false,
					ccxwfccz_2_2_5: {
						cellCode: "ccxwfccz_2_2_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_2_3_1: {
					disabledccxwfccz_2_3_1: false,
					ccxwfccz_2_3_1: {
						cellCode: "ccxwfccz_2_3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_2_3_2: '',
				ccxwfccz_2_3_3: '',
				ccxwfccz_2_3_4: {
					disabledccxwfccz_2_3_4: false,
					ccxwfccz_2_3_4: {
						cellCode: "ccxwfccz_2_3_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwfccz_2_3_5: {
					disabledccxwfccz_2_3_5: false,
					ccxwfccz_2_3_5: {
						cellCode: "ccxwfccz_2_3_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
		
			}
		
	}
	return obj
}
